<template>
  <div class="form-group">
    <label v-if="label" class="form-label">{{ label }}
      <i v-if="parseBoolean(required)" class="far fa-asterisk"></i>
      <span v-if="language" class="language"> ({{ language }})</span>
    </label>
    <div v-bind:class="{'is-invalid': invalid}">
      <div v-for="(option, i) in options" v-bind:key="i" class="form-check">
        <input v-bind:id="id + ':' + option.id"
               v-bind:name="id"
               type="checkbox"
               v-bind:value="option.id"
               v-bind:checked="isChecked(option.id)"
               v-on:change="changed"
               v-bind:disabled="option.disabled"
               class="form-check-input"
               v-bind:class="{'is-invalid': invalid}"/>
        <label v-bind:for="id + ':' + option.id"
               class="control-label">{{ option.name }}<span
            v-for="(tag, j) in option.tags"
            v-bind:key="j"
            v-bind:style="tag.style"
            v-bind:class="tag.styleClass">{{ tag.name }}</span></label>
      </div>
    </div>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text">
      <slot name="help"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "select-many-checkbox",
  computed: {
    help: function () {
      return !!this.$slots.help;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    }
  },
  methods: {
    isChecked: function (value) {
      if (this.value) {
        for (var i = 0; i < this.value.length; i++) {
          if (this.value[i] == value) {
            return true;
          }
        }
      }
      return false;
    },
    changed: function (event) {
      var newValue = this.value || [];
      if (event.target.checked) {
        newValue.push(event.target.value);
      } else {
        for (var i = 0; i < newValue.length; i++) {
          if (newValue[i] == event.target.value) {
            newValue.splice(i--, 1);
          }
        }
      }
      this.$emit("input", newValue);
    }
  },
  props: ["id", "value", "options", "errors", "label", "language", "required"]
}
</script>
